var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRiskHigh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 67,
    viewBox: "0 0 9 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16699 22.9887H0.999501V7.00006C0.999501 3.68635 3.68579 1.00005 6.9995 1.00005H8.16699V22.9887Z",
    fill: "#FF4B62"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 66.0001H7C3.68629 66.0001 1 63.3138 1 60.0001V44.0001H8V66.0001Z",
    fill: "#FF4B62"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01074 42.7119H0.998989V24H8.01074V42.7119Z",
    fill: "#FF4B62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRiskHigh);
export default __webpack_public_path__ + "static/media/icon-risk-high.6e91d7ad542becee16cc7b3414f63aa5.svg";
export { ForwardRef as ReactComponent };